<template>
  <div>
    <div v-if="loaded_values">
      <div style="background-color:darkgray;color:white;padding:8px;margin-bottom:8px"><strong>{{field.field_name}}</strong></div>
      <div style="margin-bottom: 8px;">
        Auto value:
        <el-autocomplete class="inline-input" :disabled="true" v-model="field.auto_value"></el-autocomplete>
        <span v-if="field.was_confirmed">
          <i class="el-icon-check"></i> Auto value was confirmed
        </span>
        <span v-else-if="field.auto_value">
          <el-button icon="el-icon-check" @click="save(true)"></el-button>
        </span>
      </div>
      <div style="margin-bottom:15px;">
        Manual value:
        <el-autocomplete :fetch-suggestions="filter" v-model="form_values.manual_value"></el-autocomplete>
        <el-button @click="save(false)" v-if="this.form_values.manual_value && form_values.manual_value !== this.field.manual_value">Save</el-button>
        {{who_text}}
      </div>
      <div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManualFieldEditor",
  props: ['field_prop','extent_id','asset_id','asset_type'],
  mounted() {
    console.log('MOUNTED MANUAL FIELD EDITOR')
    this.field = this.field_prop
    this.form_values.manual_value = this.field.manual_value ? this.field.manual_value : ''
    this.loaded_values = true
    console.log('this.asset_id: ' + this.asset_id)
    console.log('this.asset_type: ' + this.asset_type)
    console.log('this.field: ' + this.field_prop)
    console.log('this.field.manual_value: ' + this.field.manual_value)
    console.log('this.loaded_values: ' + this.loaded_values)
  },
  computed: {
    who_text: function () {
      if (this.field.have_manual) {
        return 'by ' + this.field.user_name + ' ' + this.field.last_updated
      } else {
        return ''
      }
    },
  },
  data() {
    return {
      loaded_values: false,
      form_values: {
        manual_value: '',
      },
      field: null,
    }
  },
  methods: {
    filter(queryString, cb) {
      console.log(queryString)
      console.log(this.field)
      if (!this.field.existing_values) cb([])
      let results = this.field.existing_values.filter(value => {
        return (value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }).map(element => {return {value: element}})
      // call callback function to return suggestions
      cb(results);
    },
    save(confirm_existing) {
      let field_value = this.form_values.manual_value
      if (confirm_existing) {
        field_value = this.field.auto_value
        this.form_values.manual_value = field_value
      }
      axios.post('/api/assets/manual_overrides/' + this.extent_id, {
        field_name: this.field.field_name,
        field_value: field_value,
        asset_id: this.asset_id,
        asset_type: this.asset_type,
        was_confirmed: this.field.auto_value === field_value,
        is_new_value:
            (this.field.auto_value !== field_value) &&
            (!this.field.existing_values.includes(field_value))
      })
          .then(response => {
            // reset form values
            this.field = response.data
            console.log('saved')
            console.log(response.data)
          })
          .catch(error => {
            console.log('oops could not save')
          })
    },
  },
}
</script>

<style scoped>

</style>